import { useGetCourseQuery } from "@api/course";
import LoadingSpinner from "@components/LoadingSpinner";
import { CourseFeatures } from "@onetutor/shared/type";
import { JSX } from "react";
import { useParams } from "react-router";
import { Navigate } from "react-router";

interface RequireFeatureProps {
  children: JSX.Element;
  feature: CourseFeatures;
}

export const RequireFeature = ({
  children,
  feature,
}: RequireFeatureProps): JSX.Element => {
  const { courseId } = useParams();

  if (!courseId) {
    return <Navigate to="/" replace />;
  }

  const { data: course, isLoading } = useGetCourseQuery(courseId);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!course) {
    return <Navigate to="/" replace />;
  }

  const featureEnabled = course.enabledFeatures?.includes(feature);

  if (!featureEnabled) {
    return <Navigate to={`/course/${courseId}`} replace />;
  }

  return children;
};
